/**
 * Amplitude Feature Flag Experiment 'feature key' constants
 */
export const AmplitudeExperiments = {
    AverageLotValueTrendingItems: 'sear-866-alv-trending-items',
    AverageLotValueActionCalendarRanking: 'sear-1266-alv-auction-calendar-ranking',
    // User sees new Checkout/Confirmation page that will let them navigate to other parts of the app more easily
    ConfirmationPageNavigation: 'confirmation-page-nav',
    DynamicArtQuickPills: 'sear-1007-dynamic-art-quick-pills',
    ElasticOnCategoryPages: 'sear-641-use-of-elastic-on-category-pages',
    ExposureVsPageViewedCheck: 'exposure-vs-page-viewed-check',
    CookiebotUiRedesign: 'laac-1570-cookiebot-ui-redesign',
    ItemPageDiscoverMoreFromThisAuction: 'laac-1126-item-page-discover-more-from-this-auction',
    ItemPageSaveIconMicroAnimation: 'laac-1918-item-page-save-icon-micro-animation',
    ItemPageStickyBidPanel: 'laac-1767-item-page-sticky-bid-panel',
    // new bidding console experiment
    NewBiddingConsole: 'laac-1705-live-bidding-console-phase1-v3',
    NoReservePriceBadge: 'la-display-no-reserve-message',
    PopularityScoreReRanking: 'sear-1021-popularity-score-re-ranking-v2',
    PurchaseProtectionMessaging: 'ups-4437',
    RecommendedForYouMyItems: 'sear-1459-recommended-for-you-my-items',
    ReplaceRecommendedItemsWithSimilarLots: 'sear-1274-recommended-items-using-similar-lots',
    SearchByImage: 'sear-1251-search-by-image',
    SearchResultsAdExperiment: 'ups-4049',
    SearchInputRedesignExperiment: 'sear-1113-recent-searches-dropdown',
    SimilarLotsUnifiedClip: 'sear-1381-similar-lots-unified-clip',
    SimplifiedCategoryPage: 'simplified-category-page',
    VariantJumpingHomePageCheck: 'variant-jumping-home-page-check',
} as const;

export type AmplitudeExperimentIds = (typeof AmplitudeExperiments)[keyof typeof AmplitudeExperiments];

export const AmplitudeVariants: {
    [key in keyof typeof AmplitudeExperiments]: {
        [variant: string]: string;
        Control: 'control';
        Treatment?: 'treatment';
    };
} = {
    AverageLotValueTrendingItems: {
        Control: 'control',
        Treatment: 'treatment',
    },
    AverageLotValueActionCalendarRanking: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ConfirmationPageNavigation: {
        Control: 'control',
        EasyNavigationDesign: 'treatment',
    },
    CookiebotUiRedesign: {
        Control: 'control',
        Treatment: 'treatment',
    },
    DynamicArtQuickPills: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ElasticOnCategoryPages: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ExposureVsPageViewedCheck: {
        Control: 'control',
        Off: 'off',
        Treatment: 'treatment',
    },
    ItemPageDiscoverMoreFromThisAuction: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ItemPageSaveIconMicroAnimation: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ItemPageStickyBidPanel: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NewBiddingConsole: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NoReservePriceBadge: {
        Control: 'control',
        Treatment: 'treatment',
    },
    PopularityScoreReRanking: {
        AddPopularityKeepingBidCount: 'treatmenta',
        AddPopularityRemovingBidCount: 'treatmentb',
        Control: 'control',
    },
    PurchaseProtectionMessaging: {
        Control: 'control',
        Treatment: 'treatment',
    },
    RecommendedForYouMyItems: {
        CarouselBelowPagination: 'treatmentb',
        CarouselTop: 'treatmenta',
        Control: 'control',
    },
    ReplaceRecommendedItemsWithSimilarLots: {
        Control: 'control',
        LastTwoViewedLots: 'treatmenta',
        LastTwoSavedLots: 'treatmentb',
    },
    SearchByImage: {
        Control: 'control',
        TreatmentA: 'treatmenta',
        TreatmentB: 'treatmentb',
    },
    SearchResultsAdExperiment: {
        Control: 'control',
        NewDesign: 'new-design',
    },
    SearchInputRedesignExperiment: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SimilarLotsUnifiedClip: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SimplifiedCategoryPage: {
        Control: 'control',
        Treatment: 'treatment',
    },
    VariantJumpingHomePageCheck: {
        Control: 'control',
        Treatment: 'treatment',
    },
} as const;

export type AmplitudeExperimentsVariantIds = (typeof AmplitudeVariants)[keyof typeof AmplitudeVariants];
